import { IIconProps } from './icon';

export const IconCalendar = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconCalendar${cy}`}
    >
      <path
        d="M4 6.83203H2.66667V8.16536H4V6.83203ZM6.66667 6.83203H5.33333V8.16536H6.66667V6.83203ZM9.33333 6.83203H8V8.16536H9.33333V6.83203ZM10.6667 2.16536H10V0.832031H8.66667V2.16536H3.33333V0.832031H2V2.16536H1.33333C0.593333 2.16536 0.00666666 2.76536 0.00666666 3.4987L0 12.832C0 13.5654 0.593333 14.1654 1.33333 14.1654H10.6667C11.4 14.1654 12 13.5654 12 12.832V3.4987C12 2.76536 11.4 2.16536 10.6667 2.16536ZM10.6667 12.832H1.33333V5.4987H10.6667V12.832Z"
        fill="white"
      />
    </svg>
  );
};
